import request from "@/axios.js";
import { reject, resolve } from "core-js/fn/promise";

export default class Contract {
	/**
	 * Contract class
	 * @param {object} contract - Contract object
	 * @property {number} type - a type.
	 * @property {number} duration - a duration.
	 * @property {Date} startDate - an startDate.
	 * @property {Date} endDate - a endDate.
	 * @property {number} status - a status.
	 * @property {string} detail - a detail.
	 * @property {string} estimate_link - a estimate_link.
	 * @property {string} commentary - a commentary.
	 * @property {number} max_price_netlink - a max_price_netlink.
	 * @property {number} society_id - an society_id.
	 * @property {string} bccgv_link - an bccgv_link.
	 * @property {number} delivery - delivery of the contract
	 */
	constructor(contract) {
		this.id = contract.id || null;
		this.type = contract.type || 0;
		this.duration = contract.duration || 0;
		this.status = contract.status || 0;
		this.creation_date = contract.creation_date || null;
		this.start_date = contract.start_date || null;
		this.end_date = contract.end_date || null;
		this.detail = contract.detail|| null;
		this.estimate_link = contract.estimate_link|| null;
		this.commentary = contract.commentary|| null;
		this.max_price_netlink = contract.max_price_netlink|| null;
		this.society_id = contract.society_id|| null;
		this.bccgv_link = contract.bccgv_link|| null;
		this.delivery = contract.delivery|| null;
		this.commercial_id = contract.commercial_id|| null;
		this.account_managers = contract.account_managers|| null;
		this.max_budget = contract.max_budget || 0;
		this.early_cancellation = contract.early_cancellation || 0;
		this.early_cancellation_duration = contract.early_cancellation_duration || 0;
		this.engagement_duration = contract.engagement_duration || null;
		this.program_end_date = contract.program_end_date || null;
		this.termination_reason_id = contract.termination_reason_id || 0;
	}

	/**
	 * Create an object to be used for forms (on creation)
	 * @return {object} contract object
	 */
	static getFormFields() {
		return {
			type: 0,
			duration: null,
			status: 0,
			creation_date: null,
			startDate: null,
			endDate: 0,
			detail: null,
			estimate_link: null,
			commentary: null,
			max_price_netlink: null,
			society_id: null,
			bccgv_link: null,
			delivery: 0,
			commercial_id: null,
			account_managers: [],
			max_budget: null,
			early_cancellation: 0,
			early_cancellation_duration: 0,
			engagement_duration: null,
			termination_reason_id: 0,
			program_end_date: null
		};
	}

	static getContractsforSociety(societyId, callback){
		//console.log(societyId);
		request.get("contract/getcs/" + societyId)
			.then(res => {
				callback(null, res.data);
			})
			.catch(err => {
				callback(err, null);
			});
	}
	static getById(id){
		return new Promise((resolve, reject) =>{
				request.get("contract/get/" + id)


					.then(res => {
						//console.log(res);
						resolve(res.data);
					})
					.catch(err => {
						//console.log(err);
						reject(err);
					});
			} )
	}
		static getAll(){
			return new Promise((resolve, reject) =>{
				request.get("contract/all/")


					.then(res => {
						//console.log(res);
						resolve(res.data);
					})
					.catch(err => {
						//console.log(err);
						reject(err);
					});
			} )
	}


	static getActiveContracts(callback){
		request.get("contract/getas/")
			.then(res => {
				callback(null, res.data);
			})
			.catch(err => {
				callback(err, null);
			});
	}

	static getRankwellforContract(contractId, callback){
		//console.log(contractId);
		request.get("contract/getrankwell/" + contractId)
			.then(res => {
				callback(null, res);
			})
			.catch(err => {
				callback(err, null);
			});
	}

	async updateUserRelation(contractId, contractOld, usersId){

		/*
		 * let resultNew = this.account_managers.filter(accountmanager => !contractOld.includes(accountmanager))
		 * let resultDel = contractOld.filter(accountmanager => !this.account_managers.includes(accountmanager))
		 */
		let resultNew = [];
		let resultDel = [];
		if(contractOld.length > 0 && this.account_managers.length > 0){
			//console.log("NEW contractOld != [] && this.account_managers != []");
			resultNew = this.account_managers.filter(accountmanager => {
				for(let accountmanagerToCompare of contractOld){
					if(this.compareAccountManager(accountmanager, accountmanagerToCompare)){
						return false;
					}
				}
				return true;
				// !contractOld.includes(accountmanager)
			});
		}
		else if(contractOld.length < 1 && this.account_managers.length > 0){
			//console.log("NEW contractOld == [] && this.account_managers != []");
			resultNew = JSON.parse(JSON.stringify(this.account_managers));
		}

		if(contractOld.length > 0 && this.account_managers.length > 0){
			//console.log("DEL contractOld != [] && this.account_managers != []");
			resultDel = contractOld.filter(accountmanager => {
				for(let accountmanagerToCompare of this.account_managers){
					if(this.compareAccountManager(accountmanager, accountmanagerToCompare)){
						return false;
					}
				}
				return true;
				// !this.account_managers.includes(accountmanager)
			});
		}
		else if(contractOld.length > 0 && this.account_managers.length < 1){
			//console.log("DEL contractOld != [] && this.account_managers == []");
			resultDel = JSON.parse(JSON.stringify(contractOld));
		}
		//console.log("resultNew", resultNew);
		//console.log("resultDel", resultDel);
		// let resultUpd = this.account_managers.filter(account_manager => contractOld)
		let requestsToProcess = [];
		if(resultDel.length > 0){
			for(let row of resultDel){
				requestsToProcess.push({
					action: "DEL",
					data: row,
					key: contractId,
					user: usersId
				});
			}
		}
		if(resultNew.length > 0){
			for(let row of resultNew){
				requestsToProcess.push({
					action: "ADD",
					data: row,
					key: contractId,
					user: usersId
				});
			}
		}

	
		//console.log("requestsToProcess", requestsToProcess);
		//console.log("processRequests BEGIN");
		await this.processRequests(requestsToProcess);
		console.log("processRequests END");
	}

	async processRequests(requestsToProcess){
		/*
		 * let unknownActionRequest = []
		 * let errRequest = []
		 */
		//console.log("requestNumber", requestNumber);
		for(let i = 0; i <= requestsToProcess.length-1; i++){
			let request = requestsToProcess[i];
			if(request.action == "DEL"){
				this.deleteAM(request.user, request.data, request.key, (err, res) => {
					if(err) console.log("Error", request, err);
					if(res) console.log(request.action, request.data, "Success");
					// this.processRequests(requestsToProcess);
				});
			}
			else if(request.action == "ADD"){
				this.createAM(request.user, request.data, request.key, (err, res) => {
					if(err) console.log("Error", request, err);
					if(res) console.log(request.action, request.data, "Success");
					// this.processRequests(requestsToProcess);
				});
			}
			// else{
			// 	//console.log("Unknown Action", request);
			// 	this.processRequests(requestsToProcess);
			// }
		}
		return;

	}

	createAM(users_id, account_manager, contractId, callback){
		//console.log("NEW", account_manager);
		//ADD Account manager
		request.post("contract/newcu", {
			contract_id: contractId,
			society_id: this.society_id,
			user_id: account_manager.id,
			type: 1,
			is_lead: account_manager.is_lead,
			users_id: users_id
		})
			.then(res => {
				//console.log(res);
				callback(null, res);
			})
			.catch(err => {
				//console.log(err);
				callback(err, null);
			});
	}
	deleteAM(usersId, account_manager, contractId, callback){
		//console.log("DELETE", account_manager);
		//console.log(contractId);
		//console.log(account_manager.id);
		//DELETE Account manager
		request.delete("contract/deletecu", {
			data: {
				contract_id: contractId,
				user_id: account_manager.id,
				type: 1,
				users_id: usersId
			}
		})
			.then(res => {
				//console.log(res);
				callback(null, res);
			})
			.catch(err => {
				//console.log(err);
				callback(err, null);
			});
	}

	delete(callback){
		request.delete("contract/delete", {
			data: {
				id: this.id
			}
		})
			.then(res => {
				callback(null, res);
			})
			.catch(err => {
				callback(err, null);
			});

	}
	/**
	 * Get Notes of contract
	 * @param {Number} contractId 
	 * @returns 
	 */
	static async getNotes(contractId){
		return new Promise((resolve, reject) =>{
			request.get("contract/getNotes/" + contractId)
			.then(res => {
				resolve(res);
			})
			.catch(err => {
				reject(err);
			});
		} )

	}
	

	compare(contractToCompare){
		for(let key in contractToCompare) {
			if(this[key] != contractToCompare[key]){
				return false;
			}
		}
		return true;
	}

	compareAccountManager(account_manager, account_manager_old){
		//console.log("account_manager", account_manager);
		//console.log("account_manager_old", account_manager_old);
		for(let key in account_manager_old) {
			//console.log(account_manager[key]);
			//console.log(account_manager_old[key]);
			if(account_manager[key] != account_manager_old[key]){
				return false;
			}
		}
		return true;
	}
}
